import { render, staticRenderFns } from "./tutorials.vue?vue&type=template&id=488535c6"
import script from "./tutorials.vue?vue&type=script&lang=js"
export * from "./tutorials.vue?vue&type=script&lang=js"
import style0 from "./tutorials.vue?vue&type=style&index=0&id=488535c6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports